import React from "react";
import cvData from "../data/cvData.json";

const SoftSkills = () => {
  const { softSkills } = cvData;

  return (
    <section id="soft-skills" className="glass-panel glass-sheen p-6 md:p-8">
      <h2 className="section-title">Soft Skills</h2>
      <div className="mt-6 flex flex-wrap gap-3">
        {softSkills.map((softSkill, index) => (
          <span key={index} className="glass-chip">
            {softSkill}
          </span>
        ))}
      </div>
    </section>
  );
};

export default SoftSkills;
